import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    BooleanField,
    ReferenceField,
    FunctionField,
    EditButton,
    ShowButton,
    Filter,
    TextInput,
    ReferenceInput,
    SelectInput,
    BooleanInput,
} from 'react-admin';
import { Chip } from '@material-ui/core';

const UserDocumentFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput
            label="User"
            source="userId"
            reference="users"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput label="Document Type" source="documentType" />
        <BooleanInput label="Verified Only" source="isVerified" />
    </Filter>
);

const UserDocumentList = (props: any) => (
    <List
        {...props}
        // filters={<UserDocumentFilter />}
        sort={{ field: 'createdAt', order: 'DESC' }}
        perPage={25}
    >
        <Datagrid>
            <TextField source="id" />
            <ReferenceField source="userId" reference="users" link="show">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="documentType" />
            <TextField source="documentNumber" />
            <DateField source="expiryDate" />
            <FunctionField
                label="File"
                render={(record: any) =>
                    record.fileName ? (
                        <a
                            href={record.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {record.fileName}
                        </a>
                    ) : (
                        <span style={{ color: '#999' }}>No file</span>
                    )
                }
            />
            <FunctionField
                label="Verified"
                render={(record: any) =>
                    record.isVerified ? (
                        <Chip label="Verified" color="primary" size="small" />
                    ) : (
                        <Chip label="Not Verified" size="small" />
                    )
                }
            />
            <DateField source="createdAt" showTime />
            <ShowButton />
            {/* <EditButton /> */}
        </Datagrid>
    </List>
);

export default UserDocumentList;
